var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfo6 = function SvgInfo6(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_20570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7436 28.0641C32.8179 28.0641 34.4994 26.3826 34.4994 24.3083C34.4994 22.234 32.8179 20.5525 30.7436 20.5525C28.6693 20.5525 26.9878 22.234 26.9878 24.3083C26.9878 26.3826 28.6693 28.0641 30.7436 28.0641Z",
    fill: "#00CB82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5373 27.6736C12.4373 27.6736 13.9776 26.1334 13.9776 24.2333C13.9776 22.3333 12.4373 20.793 10.5373 20.793C8.63722 20.793 7.09692 22.3333 7.09692 24.2333C7.09692 26.1334 8.63722 27.6736 10.5373 27.6736Z",
    fill: "#00CB82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2161 33.3826C15.3852 30.9857 13.1387 29.3688 10.6021 29.3419C8.06552 29.3149 5.7852 30.8838 4.90356 33.2624",
    fill: "#00CB82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1887 35.1551H37.0835C36.5431 32.069 33.8617 29.8187 30.7286 29.8218C30.4217 29.8238 30.1154 29.8489 29.8122 29.8969L31.7803 35.1551H29.3465L27.2282 29.4913C27.0745 29.0698 26.6702 28.7923 26.2217 28.8002H17.403C17.2272 28.7999 17.0623 28.885 16.9607 29.0284C16.8592 29.1718 16.8336 29.3557 16.8922 29.5213L19.0255 35.2001H3.47636C2.85407 35.2001 2.34961 35.7046 2.34961 36.3269C2.34961 36.9492 2.85407 37.4536 3.47636 37.4536H37.1887C37.811 37.4536 38.3154 36.9492 38.3154 36.3269C38.3154 35.7046 37.811 35.2001 37.1887 35.2001V35.1551ZM22.8114 31.264C23.3157 31.264 23.7704 31.5678 23.9634 32.0338C24.1564 32.4997 24.0497 33.0361 23.6931 33.3927C23.3365 33.7493 22.8001 33.856 22.3342 33.663C21.8682 33.47 21.5644 33.0153 21.5644 32.511C21.5644 32.1803 21.6958 31.8631 21.9296 31.6293C22.1635 31.3954 22.4807 31.264 22.8114 31.264Z",
    fill: "#00CB82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2962 18.2715L23.3346 12.502C23.261 12.048 22.8706 11.7134 22.4107 11.7101H20.9401V4.96023C20.9401 4.17925 20.307 3.54614 19.526 3.54614C18.745 3.54614 18.1119 4.17925 18.1119 4.96023V11.7101H16.7544C16.2945 11.7134 15.9041 12.048 15.8305 12.502L14.8689 18.2715C14.7605 18.564 14.8104 18.8918 15.0009 19.1388C15.1802 19.3468 15.4428 19.4643 15.7174 19.4593H23.41C23.6846 19.4643 23.9472 19.3468 24.1265 19.1388C24.33 18.8988 24.3942 18.5704 24.2962 18.2715Z",
    fill: "#00CB82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_20570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.33252 0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo6, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-6.e8bc7f40.svg";
export { ForwardRef as ReactComponent };